import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "..";
import { QR_LOGIN_FEATURE_KEY, QrLoginState } from "./qrLogin.slice";

const getQrLoginState = (rootState: StoreState): QrLoginState => rootState[QR_LOGIN_FEATURE_KEY];

const getAccessToken = createSelector(getQrLoginState, (state: QrLoginState) => state.operation?.result?.accessToken ?? "");

const getLoginRequestToken = createSelector(getQrLoginState, (state: QrLoginState) => state.loginRequestToken);

const getLoginRequestTokenSVG = createSelector(getQrLoginState, (state: QrLoginState) => state.loginRequestTokenSVG);

const getOperation = createSelector(getQrLoginState, (state: QrLoginState) => state.operation)

const getStatus = createSelector(getQrLoginState, (state: QrLoginState) => state.operation?.state ?? "PENDING")

export const qrLoginSelectors = {
    getAccessToken,
    getLoginRequestToken,
    getOperation,
    getLoginRequestTokenSVG,
    getStatus
};